// extracted by mini-css-extract-plugin
export var section = "banner-module--section--3xBji";
export var inner = "banner-module--inner--1qr9K";